export const RobotoSlabFont = {
    spacing: 50,
    glyphs: {
        ' ': {
            xMin: 0,
            xMax: 509,
            yMin: 0,
            yMax: 2000,
            ha: 2000,
            leftSideBearing: 0,
            advanceWidth: 509,
        },
        '0': {
            xMin: 121,
            xMax: 1048,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 121,
            advanceWidth: 1168,
        },
        '1': {
            xMin: 117,
            xMax: 767,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 117,
            advanceWidth: 844,
        },
        '2': {
            xMin: 75.8474576645637,
            xMax: 1040,
            yMin: 0,
            yMax: 1477,
            ha: 1477,
            leftSideBearing: 75,
            advanceWidth: 1131,
        },
        '3': {
            xMin: 74.85365853658536,
            xMax: 994,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 74,
            advanceWidth: 1106,
        },
        '4': {
            xMin: 63,
            xMax: 1114,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 63,
            advanceWidth: 1187,
        },
        '5': {
            xMin: 96.8448275474953,
            xMax: 982,
            yMin: -21,
            yMax: 1456,
            ha: 1477,
            leftSideBearing: 96,
            advanceWidth: 1081,
        },
        '6': {
            xMin: 121,
            xMax: 1067,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 121,
            advanceWidth: 1144,
        },
        '7': {
            xMin: 76,
            xMax: 1060,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: -30,
            advanceWidth: 1128,
        },
        '8': {
            xMin: 92,
            xMax: 1039,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 92,
            advanceWidth: 1131,
        },
        '9': {
            xMin: 84,
            xMax: 1026,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 84,
            advanceWidth: 1154,
        },
        '!': {
            xMin: 143,
            xMax: 340,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 143,
            advanceWidth: 483,
        },
        '"': {
            xMin: 166,
            xMax: 634,
            yMin: 1055,
            yMax: 1560,
            ha: 505,
            leftSideBearing: 166,
            advanceWidth: 770,
        },
        '#': {
            xMin: 63,
            xMax: 1179,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 63,
            advanceWidth: 1246,
        },
        $: {
            xMin: 81.92156915727656,
            xMax: 1012,
            yMin: -208,
            yMax: 1693,
            ha: 1901,
            leftSideBearing: 81,
            advanceWidth: 1110,
        },
        '%': {
            xMin: 77,
            xMax: 1384,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 77,
            advanceWidth: 1460,
        },
        '&': {
            xMin: 74,
            xMax: 1242,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 74,
            advanceWidth: 1289,
        },
        "'": {
            xMin: 166,
            xMax: 324,
            yMin: 1055,
            yMax: 1560,
            ha: 505,
            leftSideBearing: 166,
            advanceWidth: 460,
        },
        '(': {
            xMin: 114,
            xMax: 650,
            yMin: -463,
            yMax: 1636,
            ha: 2099,
            leftSideBearing: 114,
            advanceWidth: 662,
        },
        ')': {
            xMin: 11,
            xMax: 547,
            yMin: -463,
            yMax: 1636,
            ha: 2099,
            leftSideBearing: 11,
            advanceWidth: 654,
        },
        '*': {
            xMin: 66,
            xMax: 893,
            yMin: 607,
            yMax: 1456,
            ha: 849,
            leftSideBearing: 66,
            advanceWidth: 958,
        },
        '+': {
            xMin: 73,
            xMax: 1071,
            yMin: 146,
            yMax: 1206,
            ha: 1060,
            leftSideBearing: 73,
            advanceWidth: 1145,
        },
        ',': {
            xMin: 23,
            xMax: 315,
            yMin: -311,
            yMax: 221,
            ha: 532,
            leftSideBearing: 23,
            advanceWidth: 404,
        },
        '-': {
            xMin: 154,
            xMax: 643,
            yMin: 538,
            yMax: 692,
            ha: 154,
            leftSideBearing: 154,
            advanceWidth: 797,
        },
        '.': {
            xMin: 145,
            xMax: 342,
            yMin: 0,
            yMax: 202,
            ha: 202,
            leftSideBearing: 145,
            advanceWidth: 493,
        },
        '/': {
            xMin: 0,
            xMax: 774,
            yMin: -125,
            yMax: 1456,
            ha: 1581,
            leftSideBearing: 0,
            advanceWidth: 824,
        },
        ':': {
            xMin: 145,
            xMax: 342,
            yMin: 0,
            yMax: 1082,
            ha: 1082,
            leftSideBearing: 145,
            advanceWidth: 419,
        },
        ';': {
            xMin: 53,
            xMax: 345,
            yMin: -311,
            yMax: 1082,
            ha: 1393,
            leftSideBearing: 53,
            advanceWidth: 424,
        },
        '<': {
            xMin: 76,
            xMax: 892,
            yMin: 107,
            yMax: 1013,
            ha: 906,
            leftSideBearing: 76,
            advanceWidth: 1017,
        },
        '=': {
            xMin: 147,
            xMax: 981,
            yMin: 407,
            yMax: 987,
            ha: 580,
            leftSideBearing: 147,
            advanceWidth: 1127,
        },
        '>': {
            xMin: 125,
            xMax: 980,
            yMin: 87,
            yMax: 993,
            ha: 906,
            leftSideBearing: 125,
            advanceWidth: 1060,
        },
        '?': {
            xMin: 65.92660602419838,
            xMax: 890,
            yMin: 0,
            yMax: 1477,
            ha: 1477,
            leftSideBearing: 65,
            advanceWidth: 953,
        },
        '@': {
            xMin: 84.3592218305664,
            xMax: 1705.2346925277395,
            yMin: -453,
            yMax: 1431,
            ha: 1884,
            leftSideBearing: 84,
            advanceWidth: 1821,
        },
        A: {
            xMin: 70,
            xMax: 1463,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 70,
            advanceWidth: 1533,
        },
        B: {
            xMin: 81,
            xMax: 1253,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1322,
        },
        C: {
            xMin: 80,
            xMax: 1174,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 80,
            advanceWidth: 1290,
        },
        D: {
            xMin: 81,
            xMax: 1291,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1356,
        },
        E: {
            xMin: 81,
            xMax: 1190,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1306,
        },
        F: {
            xMin: 81,
            xMax: 1176,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1256,
        },
        G: {
            xMin: 80,
            xMax: 1226,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 80,
            advanceWidth: 1346,
        },
        H: {
            xMin: 81,
            xMax: 1497,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1578,
        },
        I: {
            xMin: 81,
            xMax: 604,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 685,
        },
        J: {
            xMin: 60,
            xMax: 1100,
            yMin: -21,
            yMax: 1456,
            ha: 1477,
            leftSideBearing: 60,
            advanceWidth: 1169,
        },
        K: {
            xMin: 81,
            xMax: 1427,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1501,
        },
        L: {
            xMin: 81,
            xMax: 1130,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1210,
        },
        M: {
            xMin: 94,
            xMax: 1888,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 94,
            advanceWidth: 1982,
        },
        N: {
            xMin: 83,
            xMax: 1509,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 83,
            advanceWidth: 1592,
        },
        O: {
            xMin: 70,
            xMax: 1281,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 70,
            advanceWidth: 1351,
        },
        P: {
            xMin: 81,
            xMax: 1242,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1297,
        },
        Q: {
            xMin: 70,
            xMax: 1348,
            yMin: -245,
            yMax: 1477,
            ha: 1722,
            leftSideBearing: 70,
            advanceWidth: 1376,
        },
        R: {
            xMin: 81,
            xMax: 1285,
            yMin: 0,
            yMax: 1455,
            ha: 1455,
            leftSideBearing: 81,
            advanceWidth: 1385,
        },
        S: {
            xMin: 115,
            xMax: 1116,
            yMin: -21,
            yMax: 1477,
            ha: 1498,
            leftSideBearing: 115,
            advanceWidth: 1206,
        },
        T: {
            xMin: 96,
            xMax: 1306,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 96,
            advanceWidth: 1406,
        },
        U: {
            xMin: 70,
            xMax: 1452,
            yMin: -21,
            yMax: 1456,
            ha: 1477,
            leftSideBearing: 70,
            advanceWidth: 1522,
        },
        V: {
            xMin: 65,
            xMax: 1443,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 65,
            advanceWidth: 1508,
        },
        W: {
            xMin: 72,
            xMax: 2057,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 72,
            advanceWidth: 2129,
        },
        X: {
            xMin: 80,
            xMax: 1449,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 80,
            advanceWidth: 1529,
        },
        Y: {
            xMin: 65,
            xMax: 1396,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 65,
            advanceWidth: 1461,
        },
        Z: {
            xMin: 90,
            xMax: 1107,
            yMin: 0,
            yMax: 1456,
            ha: 1456,
            leftSideBearing: 90,
            advanceWidth: 1197,
        },
        '[': {
            xMin: 157,
            xMax: 541,
            yMin: -312,
            yMax: 1664,
            ha: 1976,
            leftSideBearing: 157,
            advanceWidth: 573,
        },
        '\\': {
            xMin: 36,
            xMax: 830,
            yMin: -125,
            yMax: 1456,
            ha: 1581,
            leftSideBearing: 36,
            advanceWidth: 841,
        },
        ']': {
            xMin: 23,
            xMax: 408,
            yMin: -312,
            yMax: 1664,
            ha: 1976,
            leftSideBearing: 23,
            advanceWidth: 552,
        },
        '^': {
            xMin: 71,
            xMax: 802,
            yMin: 729,
            yMax: 1456,
            ha: 727,
            leftSideBearing: 71,
            advanceWidth: 864,
        },
        _: {
            xMin: 119,
            xMax: 1041,
            yMin: -154,
            yMax: 0,
            ha: 154,
            leftSideBearing: 119,
            advanceWidth: 1168,
        },
        '`': {
            xMin: 40,
            xMax: 456,
            yMin: 1288,
            yMax: 1560,
            ha: 272,
            leftSideBearing: 40,
            advanceWidth: 496,
        },
        a: {
            xMin: 79,
            xMax: 1053,
            yMin: -21,
            yMax: 1102,
            ha: 1123,
            leftSideBearing: 79,
            advanceWidth: 1132,
        },
        b: {
            xMin: -16,
            xMax: 1071,
            yMin: -21,
            yMax: 1560,
            ha: 1581,
            leftSideBearing: -16,
            advanceWidth: 1145,
        },
        c: {
            xMin: 78,
            xMax: 988,
            yMin: -21,
            yMax: 1102,
            ha: 1123,
            leftSideBearing: 78,
            advanceWidth: 1067,
        },
        d: {
            xMin: 78,
            xMax: 1156,
            yMin: -21,
            yMax: 1560,
            ha: 1581,
            leftSideBearing: 78,
            advanceWidth: 1218,
        },
        e: {
            xMin: 74,
            xMax: 980,
            yMin: -21,
            yMax: 1102,
            ha: 1123,
            leftSideBearing: 74,
            advanceWidth: 1059,
        },
        f: {
            xMin: 64,
            xMax: 731,
            yMin: 0,
            yMax: 1581,
            ha: 1581,
            leftSideBearing: 64,
            advanceWidth: 725,
        },
        g: {
            xMin: 78,
            xMax: 1133,
            yMin: -437,
            yMax: 1102,
            ha: 1539,
            leftSideBearing: 78,
            advanceWidth: 1157,
        },
        h: {
            xMin: 49,
            xMax: 1255,
            yMin: 0,
            yMax: 1560,
            ha: 1560,
            leftSideBearing: 49,
            advanceWidth: 1315,
        },
        i: {
            xMin: 67,
            xMax: 590,
            yMin: 0,
            yMax: 1560,
            ha: 1560,
            leftSideBearing: 67,
            advanceWidth: 652,
        },
        j: {
            xMin: -56,
            xMax: 381,
            yMin: -437,
            yMax: 1560,
            ha: 1997,
            leftSideBearing: -56,
            advanceWidth: 525,
        },
        k: {
            xMin: 64,
            xMax: 1248,
            yMin: 0,
            yMax: 1560,
            ha: 1560,
            leftSideBearing: 64,
            advanceWidth: 1287,
        },
        l: {
            xMin: 64,
            xMax: 587,
            yMin: 0,
            yMax: 1560,
            ha: 1560,
            leftSideBearing: 64,
            advanceWidth: 653,
        },
        m: {
            xMin: 74,
            xMax: 1905,
            yMin: 0,
            yMax: 1102,
            ha: 1102,
            leftSideBearing: 74,
            advanceWidth: 1977,
        },
        n: {
            xMin: 74,
            xMax: 1278,
            yMin: 0,
            yMax: 1102,
            ha: 1102,
            leftSideBearing: 74,
            advanceWidth: 1343,
        },
        o: {
            xMin: 78,
            xMax: 1046,
            yMin: -21,
            yMax: 1102,
            ha: 1123,
            leftSideBearing: 78,
            advanceWidth: 1124,
        },
        p: {
            xMin: 34,
            xMax: 1119,
            yMin: -416,
            yMax: 1102,
            ha: 1518,
            leftSideBearing: 34,
            advanceWidth: 1197,
        },
        q: {
            xMin: 78,
            xMax: 1135,
            yMin: -416,
            yMax: 1102,
            ha: 1518,
            leftSideBearing: 78,
            advanceWidth: 1139,
        },
        r: {
            xMin: 72,
            xMax: 808,
            yMin: 0,
            yMax: 1102,
            ha: 1102,
            leftSideBearing: 72,
            advanceWidth: 854,
        },
        s: {
            xMin: 104,
            xMax: 933,
            yMin: -21,
            yMax: 1102,
            ha: 1123,
            leftSideBearing: 104,
            advanceWidth: 1022,
        },
        t: {
            xMin: 24,
            xMax: 678,
            yMin: -17,
            yMax: 1343,
            ha: 1360,
            leftSideBearing: 24,
            advanceWidth: 730,
        },
        u: {
            xMin: 52,
            xMax: 1181,
            yMin: -21,
            yMax: 1082,
            ha: 1103,
            leftSideBearing: 52,
            advanceWidth: 1245,
        },
        v: {
            xMin: 26,
            xMax: 1176,
            yMin: 0,
            yMax: 1082,
            ha: 1082,
            leftSideBearing: 26,
            advanceWidth: 1206,
        },
        w: {
            xMin: 52,
            xMax: 1777,
            yMin: 0,
            yMax: 1082,
            ha: 1082,
            leftSideBearing: 52,
            advanceWidth: 1823,
        },
        x: {
            xMin: 42,
            xMax: 1163,
            yMin: 0,
            yMax: 1082,
            ha: 1082,
            leftSideBearing: 42,
            advanceWidth: 1203,
        },
        y: {
            xMin: 24,
            xMax: 1172,
            yMin: -437,
            yMax: 1082,
            ha: 1519,
            leftSideBearing: 24,
            advanceWidth: 1192,
        },
        z: {
            xMin: 88,
            xMax: 960,
            yMin: 0,
            yMax: 1082,
            ha: 1082,
            leftSideBearing: 88,
            advanceWidth: 1032,
        },
        '{': {
            xMin: 63,
            xMax: 671,
            yMin: -364,
            yMax: 1597,
            ha: 1961,
            leftSideBearing: 63,
            advanceWidth: 701,
        },
        '|': {
            xMin: 150,
            xMax: 307,
            yMin: -270,
            yMax: 1456,
            ha: 1726,
            leftSideBearing: 150,
            advanceWidth: 451,
        },
        '}': {
            xMin: 27,
            xMax: 635,
            yMin: -364,
            yMax: 1597,
            ha: 1961,
            leftSideBearing: 27,
            advanceWidth: 701,
        },
        '~': {
            xMin: 121,
            xMax: 1257,
            yMin: 401,
            yMax: 803,
            ha: 402,
            leftSideBearing: 121,
            advanceWidth: 1386,
        },
    },
    fontFamily: 'Roboto Slab',
    resolution: 2048,
    generatedOn: '2020-06-15T19:12:58.120Z',
};
